import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { CREATE_ACCOUNT_GROUP } from './queries';

const TYPES = [
  'Accounts Receivable',
  'Other Current Asset',
  'Bank',
  'Fixed Asset',
  'Other Asset',
  'Accounts Payable',
  'Credit Card',
  'Other Current Liability',
  'Long Term Liability',
  'Equity',
  'Income',
  'Other Income',
  'Cost of Goods Sold',
  'Expense',
  'Other Expense',
  'Non-Posting',
];

export const FIELDS = {
  name: {
    rules: { required: true }
  },
  type: {
    select: TYPES,
    rules: { required: true },
  },
};

const NewAccountGroup = ({ setShowModal, refetch }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createAccountGroup] = useMutation(CREATE_ACCOUNT_GROUP, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    createAccountGroup({ variables: prepareInput(input, FIELDS) });
  });

  return (
    <View>
      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Create Account Group" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default NewAccountGroup;
